<template>
  <div class="status">
    <div class="status-row">
      <div class="status-icon active"
        @click="setStatus(0)"
        :class="{ 'selected': station.statusType === 0 }">
        <i class="el-icon-check" />
        Active

        <i class="el-icon-message message-icon" @click="statusMessageDialog = true" v-if="station.statusType === 0"></i>
      </div>
      <div class="status-icon maintenance"
        @click="setStatus(1)"
        :class="{ 'selected': station.statusType === 1 }">
        <i class="el-icon-refresh" />
        Maintenance

        <i class="el-icon-message message-icon" @click="statusMessageDialog = true" v-if="station.statusType === 1"></i>
      </div>
      <div class="status-icon inactive"
        @click="setStatus(2)"
        :class="{ 'selected': station.statusType === 2 }">
        <i class="el-icon-close" />
        Inactive

        <i class="el-icon-message message-icon" @click="statusMessageDialog = true" v-if="station.statusType === 2"></i>
      </div>
    </div>

    <el-dialog :append-to-body="true"
        width="30%"
        custom-class="dialog-no-padding full-width-mobile"
        :visible.sync="statusMessageDialog"
        :show-close="false"
        append-to-body>
        <div class="status-message-body">
          <span>Status message</span>
          <icon-button @click="cancelStatusMessage" icon="el-icon-close" class="close-btn"/>
          <textarea v-model="station.statusMessage" class="message-area" placeholder="Message here"></textarea>
          <icon-button @click="pushStatusMessage" icon="el-icon-check" class="save-btn" />
        </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Status',
  props: {
    station: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      updated: false,
      tempMessage: '',
      statusMessageDialog: false
    }
  },
  watch: {
    'statusMessageDialog' (newVal, oldVal) {
      if (!newVal && this.updated) {
        this.updated = false
        this.tempMessage = ''
      } else if (!newVal && !this.updated) {
        this.station.statusMessage = this.tempMessage
        this.tempMessage = ''
      } else if (newVal) {
        this.tempMessage = this.station.statusMessage
      }
    }
  },
  methods: {
    cancelStatusMessage () {
      this.statusMessageDialog = false
    },
    pushStatusMessage () {
      if (this.station.statusMessage === '') {
        this.station.statusMessage = null
      }
      this.$http.put(this.$api.station(this.station.id).update,
        {...this.station, organizationId: this.station.organization.id, logoId: null})
        .then(response => {
          this.$message.success('Status message pushed')
          this.updated = true
          this.statusMessageDialog = false
        }, _ => {
          this.station.statusMessage = ''
        })
    },
    setStatus (status) {
      if (this.station.statusType === status) {
        return
      }
      const old = this.station.statusType
      const oldMessage = this.station.statusMessage
      this.station.statusType = status
      this.station.statusMessage = null
      this.$http.put(this.$api.station(this.station.id).update,
        {...this.station, organizationId: this.station.organization.id, logoId: null})
        .then(response => {}, _ => {
          this.station.statusType = old
          this.station.statusMessage = oldMessage
        })
    }
  }
}
</script>

<style lang="scss" scoped>

  .status-message-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;

    p {
      margin: 0;
    }
  }

  .status-message-body {
    position: relative;
    padding: 0px 10px;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    margin-top: 10px;

    .close-btn {
      position: absolute;
      top: 0px;
      right: 15px;
    }

    .save-btn {
      position: absolute;
      bottom: 0px;
      right: 15px;
    }

    span {
      position: absolute;
      top: 0px;
      left: 15px;
      color: #008fcc;
      font-size: 10px;
    }
  }

  .message-area {
    resize: none;
    height: 50px;
    border: none;
    margin-bottom: 10px;
    padding: 20px 5px;
    // font-family: 'Titillium Web', Helvetica, sans-serif;

    &:focus {
      outline: none;
    }
  }

  .message-row {
    width: 100%;
    box-sizing: border-box;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2);
    padding: 20px;

    .message-controls {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #909399;

      p {
        margin: 0;
      }
    }
  }

  .status {
    display: flex;
    flex-direction: column;
    width: 100%;
    box-sizing: border-box;

    .status-row {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;

      .status-icon {
        flex: 1;
        height: 250px;
        //box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2);
        margin: 0px 0px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: white;
        font-size: 14px;
        text-transform: uppercase;
        opacity: 0.4;
        transition: opacity .2s ease-out;
        position: relative;
        cursor: pointer;

        .message-icon {
          position: absolute;
          bottom: 10px;
          right: 12px;
          margin-bottom: 0px;
          font-size: 18px;
        }

        &:last-child {
          margin-right: 0px;
        }

        &:first-child {
          margin-left: 0px;
        }

        &.selected {
          opacity: 1;
        }

        &:hover {
          opacity: 1;
        }

        &.active {
          background-color: #53D788;
        }

        &.inactive {
          background-color: #FD6F71;
        }

        &.maintenance {
          background-color: #F8C764;
        }

        i {
          font-size: 38px;
          margin-bottom: 20px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/stations/station/Status.vue